/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import { NullEnum } from './nullEnum';
import { YardTypeEnum } from './yardTypeEnum';

export type PatchedHostingServicePreferencesYardType =
  | (typeof PatchedHostingServicePreferencesYardType)[keyof typeof PatchedHostingServicePreferencesYardType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchedHostingServicePreferencesYardType = { ...YardTypeEnum, ...NullEnum } as const;
